import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Link from '@mui/material/Link';
import Zoom from '@mui/material/Zoom';
import { toast } from 'react-toastify';
import { httpGet, httpPost, httpPut, httpDelete } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid'; import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import Tooltip from '@mui/material/Tooltip';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { GridRowModes, useGridApiRef } from '@mui/x-data-grid';
import { GridActionsCellItem } from '@mui/x-data-grid';
import DoneIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { getFilter, setFilter, getDisplayName } from '../Common/Utilities';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});


export default function UserInvoiceStatuses(props) {

	const [data, setData] = React.useState([]);
	const apiGridRef = useGridApiRef();
	const [inProgress, setInProgress] = React.useState(false);
	const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
	const [rowModesModel, setRowModesModel] = React.useState({});
	const [currentEditRowId, setCurrentEditRowId] = React.useState(null);
	const [isAdding, setIsAdding] = React.useState(null);
	const [openDeleteConfirmation, setOpenDeleteConfirmation] = React.useState(false);
	const [deleteRowData, setDeleteRowData] = React.useState(null);
	const [showActions, setshowActions] = React.useState(true);
	const [filterText, setFilterText] = React.useState(getFilter(['SystemSetup', 'InvoiceUserStatus', 'searchText']) || '');
	const [sortModel, setSortModel] = React.useState(getFilter(['SystemSetup', 'InvoiceUserStatus', 'sortModel']) || []);
	const [disableActionHover, setDisableActionHover] = React.useState(false);

	const userStatusLabel = getDisplayName('User Status');
	var userInfo = JSON.parse(localStorage.userInfo);
	let resourceId = userInfo.id;

	const getRefreshButton = () =>
	(<IconButton
		variant="contained"
		onClick={refresh_clickHandler}
		size="small"
		style={{ float: "right", zIndex: 1, marginTop: 10, display: 'none' }}>
		<RefreshIcon />
	</IconButton>
	);

	const getAddBoxButton = () => (
		showActions && (<IconButton
			variant="contained"
			onClick={handleAddClick}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10, display: 'block' }}
			disabled={isButtonDisabled}
		>
			<Tooltip key={1} title={'add'}><AddBoxIcon key={2} /></Tooltip>
		</IconButton>
		)
	);

	const refresh_clickHandler = async (event) => {
		setInProgress(true);
		try {
			let functionName = "getInvoiceUserStatus";
			let messageName = "InvoiceUserStatus";
			const response = await httpGet("/api/Adapter/getSyncData/" + functionName)
			const data = response.data;
			setInProgress(false);
			if (data)
				toast.success(messageName + ' Fetched Successfully');
			else
				toast.error('Error fetching ' + messageName);

		}
		catch (error) {
			setInProgress(false);
			toast.error('Error fetching ' + messageName);
		}
	};

	const isRecordValid = (data, existingInvoiceUserStatus) => {
		let isValid = true;
		let message = "";
		const newUserStatusCode = data.userStatusCode?.trim().toLowerCase();
		const newUserStatusCodeExists = existingInvoiceUserStatus.some(row => row.userStatusCode.trim().toLowerCase() === newUserStatusCode && row.rowId !== data.rowId);

		if (newUserStatusCodeExists) {
			toast.error(`This ${userStatusLabel} already exists`);
			return "";
		}

		if (!data.userStatusCode || data.userStatusCode.trim().length === 0) {
			message += `${userStatusLabel}, `;
		}

		if (!data.userStatusDescription || data.userStatusDescription.trim().length === 0) {
			message += "Description, ";
		}

		if (message.length > 0) {
			message = message.slice(0, -2);
			toast.error(`Please provide ${message}`);
			isValid = false;
		}

		return isValid;
	};

	const handleAddClick = React.useCallback(() => {
		const id = ([...data]?.sort((a, b) => b.rowId - a.rowId)[0]?.rowId + 1) || 1;
		let model = {
			rowId: id,
			isNew: true
		};
		setData((prevData) => [model, ...prevData]);
		setCurrentEditRowId(id);
		setRowModesModel((prevModel) => ({ ...prevModel, [id]: { mode: GridRowModes.Edit, fieldToFocus: 'userStatusCode' } }));
		setIsButtonDisabled(true);
		setIsAdding(true);
	}, [data, currentEditRowId]);

	const handleEditClick = React.useCallback((id) => {
		setCurrentEditRowId(id);
		setIsButtonDisabled(true);
		setIsAdding(false);
		setRowModesModel((prevModel) => ({ ...prevModel, [id]: { mode: GridRowModes.Edit } }));
	}, []);

	const handleCancelClick = React.useCallback((id) => {
		setRowModesModel((prevModel) => ({
			...prevModel,
			[id]: { mode: GridRowModes.View, ignoreModifications: true },
		}));
		setCurrentEditRowId(null);
		setIsButtonDisabled(false);
		setIsAdding(false);
		setData((prevData) => prevData.filter((row) => !(row.rowId === id && row.isNew)));
	}, []);

	const handleSaveClick = (newData) => {
		setDisableActionHover(true);
		setRowModesModel({ ...rowModesModel, [newData.rowId]: { mode: GridRowModes.View } });
		setTimeout(() => {
			setDisableActionHover(false);
		}, 300);
	};

	const handleDeleteClick = React.useCallback((rowData) => {
		setDeleteRowData(rowData);
		setOpenDeleteConfirmation(true);
	}, []);

	const closeDeleteDialog = React.useCallback(() => {
		setOpenDeleteConfirmation(false);
		setDeleteRowData(null);
	}, []);

	const deleteInvoiceUserStatus = React.useCallback(() => {
		props.inProgress(true);
		const data = deleteRowData;
		const url = `/api/setup/deleteInvoiceUserStatus/${data.invoiceUserStatusId}`;

		setOpenDeleteConfirmation(false);
		setDeleteRowData(null);

		httpDelete(url)
			.then((response) => {
				props.inProgress(false);
				toast.success('Deleted Successfully');
				fetchInvoiceUserStatus();
			})
			.catch((error) => {
				props.inProgress(false);
				if (error.response.data.includes("Cannot delete, record being referenced by other entities.")) {
					toast.error("Cannot delete, record being referenced by other entities.");
				} else {
					toast.error(<div>Delete Failed<br />{error.response.data}</div>);
				}
			});
	}, [deleteRowData, fetchInvoiceUserStatus]);

	const saveInvoiceUserStatus = React.useCallback((newdata, oldData) => {
		let rowdata = structuredClone(newdata);

		if (rowdata.isNew) {
			rowdata.createId = resourceId;
		} else {
			rowdata.modifyId = resourceId;
		}

		let endpoint = "/api/setup/saveInvoiceUserStatus";
		props.inProgress(true);

		httpPost(endpoint, rowdata)
			.then((response) => {
				props.inProgress(false);
				newdata.isNew = toast.success('Added Successfully');
				fetchInvoiceUserStatus();
				setIsButtonDisabled(false);
			})
			.catch((error) => {
				if (newdata?.isNew) {
					setData((prev) => prev.filter(e => e.rowId !== newdata.rowId));
				} else {
					setData((prev) => prev.map(e => e.rowId === newdata.rowId ? oldData : e));
				}
				props.inProgress(false);
				toast.error(<div>Update Failed<br />{error.response.data}</div>);
				setIsButtonDisabled(false);
			});
	}, [fetchInvoiceUserStatus, props]);


	const processRowUpdate = React.useCallback((newrow, oldrow) => {
		let _newrow = structuredClone(newrow);
		if (!isRecordValid(_newrow, data)) {
			setRowModesModel({ ...rowModesModel, [_newrow.rowId]: { mode: GridRowModes.Edit } });
			throw new Error('');
		}
		setCurrentEditRowId(null);
		saveInvoiceUserStatus(_newrow, oldrow);
		return newrow;
	}, [saveInvoiceUserStatus]);

	React.useEffect(() => {

		const gridRef = apiGridRef?.current;
		if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
			gridRef.setQuickFilterValues([filterText]);
		}
		fetchInvoiceUserStatus();
	}, []);


	const fetchInvoiceUserStatus = React.useCallback(() => {

		props.inProgress(true);

		httpGet('/api/setup/getInvoiceUserStatus')
			.then((response) => {
				const data = response.data;
				const records = (data.record || []).map((e, i) => ({ ...e, rowId: i }));
				setData(records);
				props.inProgress(false);
			})
			.catch((error) => {
				props.inProgress(false);

				toast.error(`An error occurred while fetching the records: ${error.message}`);
			});
	}, [props]);

	let count = 1;
	return (
		<div>
			<h1>{userStatusLabel}</h1>
			<div className="form-group">
				<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
					<EnhancedDataGrid
						rows={data}
						apiRef={apiGridRef}
						disableColumnMenu
						pagination
						editMode="row"
						pageSize={10}
						processRowUpdate={processRowUpdate}
						onProcessRowUpdateError={(err) => { }}
						rowModesModel={rowModesModel}
						setFilterText={(text) => {
							const trimmed = text?.trim() || '';
							setFilterText(trimmed);
							setFilter(['SystemSetup', 'InvoiceUserStatus', 'searchText'], trimmed);
						}}
						filterText={filterText}
						onSortModelChange={(model) => {
							setSortModel(model);
							setFilter(['SystemSetup', 'InvoiceUserStatus', 'sortModel'], model);
						}}
						sortModel={sortModel}
						columns={[
							{
								headerName: 'Status Code',
								field: 'userStatusCode',
								flex: 0.7,
								editable: true,
								cellClassName: "MuiInputBase-input MuiInput-input",
								renderEditCell: (params) => (
									<input
										type="text"
										value={params.value || ''}
										maxLength={64}
										autoFocus={params.row?.isNew}
										onChange={(e) =>
											params.api.setEditCellValue({
												id: params.id,
												field: params.field,
												value: e.target.value
											})
										}
										onKeyDown={(e) => {
											if (e.key === 'Tab') {
												e.preventDefault();
												e.stopPropagation();

												const nextField = 'userStatusDescription';

												// 1) move grid focus
												params.api.setCellFocus(params.id, nextField);

												// 2) move DOM focus to the input inside the next cell
												requestAnimationFrame(() => {
													const cellEl = params.api.getCellElement(params.id, nextField);
													const inputEl = cellEl?.querySelector('input, textarea, [contenteditable="true"]');
													inputEl?.focus();
													inputEl?.select?.();
												});
											}
										}}

										className="MuiInputBase-input MuiInput-input"
									/>
								)
							},
							{
								headerName: 'Description',
								field: 'userStatusDescription',
								flex: 1,
								editable: true,
								cellClassName: "MuiInputBase-input MuiInput-input",
								renderEditCell: (params) => (
									<input
										type="text"
										value={params.value || ''}
										maxLength={128}
										onChange={(e) =>
											params.api.setEditCellValue({
												id: params.id,
												field: params.field,
												value: e.target.value
											})
										}
										className="MuiInputBase-input MuiInput-input"
									/>
								)
							},
							...(showActions ? [{
								field: 'actions',
								type: 'actions',
								headerName: 'Actions',
								width: 150,
								cellClassName: 'actions',
								getActions: (rowData) => {
									const isInEditMode = rowModesModel[rowData.id]?.mode === GridRowModes.Edit;
									if (isInEditMode) {
										return [
											<GridActionsCellItem
												key={rowData.id + 1}
												icon={<Tooltip key={rowData.id + 2} title={'Save'}><DoneIcon key={rowData.id + 1} /></Tooltip>}
												label="Save"
												color="inherit"
												onClick={() => { handleSaveClick(rowData.row) }}
											/>,
											<GridActionsCellItem
												key={rowData.id + 2}
												icon={<Tooltip key={rowData.id + 2} title={'Cancel'}><CancelIcon key={rowData.id + 1} /></Tooltip>}
												label="Cancel"
												className="textPrimary"
												onClick={() => { handleCancelClick(rowData.id) }}
												color="inherit"
											/>,
										];
									}
									return [
										<GridActionsCellItem
											key={`edit-${rowData.id}`}
											icon={
												<Tooltip
													title="Edit"
													disableHoverListener={disableActionHover}
												>
													<span>
														<EditIcon />
													</span>
												</Tooltip>
											}
											label="Edit"
											onClick={() => handleEditClick(rowData.id)}
											color="inherit"
											disabled={isButtonDisabled}
										/>,
										<GridActionsCellItem
											key={rowData.id + 3}
											icon={<Tooltip key={rowData.id + 2} title={'Delete'}><DeleteIcon key={rowData.id + 1} /></Tooltip>}
											label="Delete"
											onClick={() => { handleDeleteClick(rowData.row) }}
											color="inherit"
											disabled={isButtonDisabled}
										/>,
									];
								}
							}] : [])
						]}
						getRowId={(row) => row.rowId}
						editable={
							{
								onRowAdd: newData =>
									new Promise((resolve, reject) => {
										newData.rowId = 0;
										newData.companyCode = parseInt(state.companyCode);

										if (isRecordValid(newData)) {
											saveInvoiceUserStatus(newData, resolve, reject);
										}
										else {
											reject();
										}
									}),
								onRowUpdate: (newData, oldData) =>
									new Promise((resolve, reject) => {

										if (isRecordValid(newData)) {
											saveInvoiceUserStatus(newData, resolve, reject);
										}
										else {
											reject();
										}
									}),
								onRowDelete: oldData =>
									new Promise((resolve, reject) => {
										deleteInvoiceUserStatus(oldData, resolve, reject);
									}),
								onRowAddCancelled: rowData =>
									new Promise((resolve, reject) => {
									}),
								onRowUpdateCancelled: rowData =>
									new Promise((resolve, reject) => {
									})
							}
						}
						customcomponent={
							(<>
								{getRefreshButton()}
								{getAddBoxButton()}
							</>)
						}
					/>
				</div>

			</div>

			<Dialog
				open={openDeleteConfirmation}
				aria-labelledby="draggable-dialog-title"
			>
				<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
					Delete Record
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Are you sure you want to delete the {userStatusLabel} "{deleteRowData ? deleteRowData.userStatusCode : ""}" ?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={deleteInvoiceUserStatus} color="primary">
						Yes
					</Button>
					<Button autoFocus onClick={closeDeleteDialog} color="primary">
						No
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
